module.exports = __webpack_public_path__ + "img/i_copy.e4125492.svg";